import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/equipos.png'
import _imports_1 from '@/assets/icons/teamLeader.png'
import _imports_2 from '@/assets/icons/verdetalle.png'


const _withScopeId = n => (_pushScopeId("data-v-27063ca1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Equipo",
  width: "40",
  height: "40"
}, null, -1))
const _hoisted_2 = { class: "ms-2" }
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { class: "text-subtitle-1 font-weight-bold ringbearer" }
const _hoisted_5 = { class: "ms-2 text-caption text-grey-lighten-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "d-flex align-center" }
const _hoisted_8 = {
  key: 0,
  class: "text-red text-caption mt-1 d-flex align-center"
}
const _hoisted_9 = { class: "d-flex align-center" }
const _hoisted_10 = { class: "d-flex align-center" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "d-flex align-center" }
const _hoisted_13 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "compact-header text-center" }, "Nombre"),
  /*#__PURE__*/_createElementVNode("th", { class: "hide-on-mobile compact-header text-center" }, " Ejército "),
  /*#__PURE__*/_createElementVNode("th", { class: "compact-header text-center" }, "Lista"),
  /*#__PURE__*/_createElementVNode("th", { class: "hide-on-mobile compact-header text-center" }, " Entrega "),
  /*#__PURE__*/_createElementVNode("th", { class: "compact-header text-center" }, "Acciones")
], -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "compact-cell text-left" }
const _hoisted_17 = {
  key: 0,
  src: _imports_1,
  alt: "Capitan",
  width: "45",
  height: "45"
}
const _hoisted_18 = {
  key: 1,
  src: _imports_2,
  alt: "Participante",
  width: "40",
  height: "40"
}
const _hoisted_19 = { class: "hide-on-mobile compact-cell" }
const _hoisted_20 = { class: "compact-cell" }
const _hoisted_21 = { class: "hide-on-mobile compact-cell" }
const _hoisted_22 = { class: "compact-cell" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  colspan: 5,
  class: "text-center py-4"
}
const _hoisted_27 = { class: "text-subtitle-1 text-center" }

import { computed, ref, toRef } from "vue";

import type { EquipoDTO, InscripcionTorneoDTO } from "@/interfaces/Inscripcion";
import {
  convertirFecha,
  obtenerFechaActual,
  formatFechaSpaWhitoutAsync,
} from "@/utils/Fecha";
import {
  eliminarEquipoAsync,
  eliminarMiembroEquipoAsync,
  updateEstadoPagoEquipo,
} from "@/services/InscripcionesService";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import ModalError from "@/components/Commons/ModalError.vue";
import {
  CrearListaTorneoRequestDTO,
  ListaJugador,
  ModificarListaTorneoRequestDTO,
  RequesListaDTO,
} from "@/interfaces/Lista";
import ModalVerLista from "@/components/Inscripcion/ModalVerLista.vue";
import ModalEnviarLista from "@/components/Inscripcion/ModalEnviarLista.vue";
import {
  getListaById,
  modificarListaTorneo,
  subirListaTorneo,
} from "@/services/ListasService";
import { Torneo } from "@/interfaces/Torneo";
import ModalCambiarEstadoListaEquipos from "./ModalCambiarEstadoListaEquipos.vue";
import { getUsuariosNoInscritosTorneoAsync } from "@/services/UsuariosService";
import { UsuarioSinEquipoDTO } from "@/interfaces/Usuario";
import ModalAddMiembroEquipo from "@/components/GestionTorneos/Equipos/ModalAddMiembroEquipo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardInfoEquipo',
  props: {
    equipo: {},
    torneo: {}
  },
  emits: ["delete-team"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const isOpenMenuAcciones = ref<{ [id: number]: boolean }>({});
const isExpanded = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const showSuccessModalPago = ref<boolean>(false);
const showSuccessModalEliminarEquipo = ref<boolean>(false);
const showVerListaModal = ref<boolean>(false);
const showEnviarCambiarListaModal = ref<boolean>(false);
const showCambiarEstadoLista = ref<boolean>(false);
const showSuccessModalLista = ref<boolean>(false);
const showErrorModalLista = ref<boolean>(false);
const showModalRegistrarMiembroEquipo = ref<boolean>(false);
const showErrorModalEliminarMiembroEquipo = ref<boolean>(false);
const showSuccessModalEliminarMiembroEquipo = ref<boolean>(false);
const showConfirmModal = ref(false);
const confirmAction = ref<() => void>();
const confirmTitle = ref("¿Estás seguro?");
const confirmText = ref("Esta acción no se puede deshacer.");
const currentInscripcionId = ref<number>();
const currentIdLista = ref<number>(0);
const currentUsuarioId = ref<number>();
const currentEmailOrganziador = ref<string>();
const currentNick = ref<string>();
const currentTorneoId = ref<number>();
const currentEstadoLista = ref<string>();
const hasLista = ref<boolean>(false);
const listaJugador = ref<ListaJugador>();
const jugadoresSinEquipo = ref<UsuarioSinEquipoDTO[]>([]);
const inscripcionesEquipo = ref<InscripcionTorneoDTO[]>([
  ...props.equipo.inscripciones,
]);
const esPago = toRef(props.equipo, "esPago");

const emit = __emit;

//Spiner
const isCargandoAccion = ref(false);
const mensajeCarga = ref("Cargando...");

const showErrorModal = ref<boolean>(false);
const toggleExpand = () => {
  isExpanded.value = !isExpanded.value;
};

const numeroMiembrosEquipo = ref<number>();
const equipoConHuecos = computed(() => {
  const miembros = inscripcionesEquipo.value ?? [];
  const faltantes = Math.max(
    0,
    (numeroMiembrosEquipo.value ?? 0) - miembros.length
  );
  return [...miembros, ...Array(faltantes).fill(null)];
});
const listasOk = computed(() => {
  return inscripcionesEquipo.value.filter((i) => i.estadoLista === "OK").length;
});
const equipoIncompleto = computed(() => {
  return listasOk.value < numeroMiembrosEquipo.value!;
});

const miembrosPorTipo: Record<string, number> = {
  Individual: 1,
  Parejas: 2,
  Equipos_4: 4,
  Equipos_6: 6,
};
numeroMiembrosEquipo.value =
  miembrosPorTipo[props.torneo.tipoTorneo ?? "Individual"] || 1;

const verLista = async (idLista: number, nombre: string, ejercito: string) => {
  const responseLista = await getListaById(idLista);
  const listaJugadorDTO: ListaJugador = {
    listaData: responseLista.data.listaData,
    nick: nombre,
    nombreEjercito: ejercito,
  };
  listaJugador.value = listaJugadorDTO;
  showVerListaModal.value = true;
};

const enviarCambiarLista = (
  idInscripcion: number | undefined,
  listaData: string,
  idUsuario: number,
  nick: string,
  idLista: number
) => {
  currentInscripcionId.value = idInscripcion;
  currentUsuarioId.value = idUsuario;
  currentNick.value = nick;
  currentIdLista.value = idLista;
  if (!listaData) hasLista.value = false;
  else hasLista.value = true;

  showEnviarCambiarListaModal.value = true;
};

const guardarLista = async (newLista: RequesListaDTO) => {
  isCargandoAccion.value = true;
  const miembroIndex = inscripcionesEquipo.value.findIndex(
    (m) => m.idInscripcion === currentInscripcionId.value
  );

  if (miembroIndex === -1) {
    isCargandoAccion.value = false;
    showErrorModalLista.value = true;
    return;
  }

  const miembro = inscripcionesEquipo.value[miembroIndex];

  const esModificacion = !!miembro.idLista;

  try {
    let nuevoIdLista = miembro.idLista;

    if (esModificacion) {
      mensajeCarga.value = "Modificando lista...";

      const requestLista: ModificarListaTorneoRequestDTO = {
        idInscripcion: currentInscripcionId.value!,
        idLista: miembro.idLista!,
        listaData: newLista.listaData,
        ejercito: newLista.ejercito,
        idUsuario: newLista.idUsuario,
        idTorneo: props.torneo.idTorneo,
      };

      await modificarListaTorneo(requestLista);
    } else {
      mensajeCarga.value = "Enviando lista...";

      const requestLista: CrearListaTorneoRequestDTO = {
        idInscripcion: currentInscripcionId.value!,
        listaData: newLista.listaData,
        ejercito: newLista.ejercito,
        idUsuario: newLista.idUsuario,
        idTorneo: props.torneo.idTorneo,
        nick: newLista.nick,
        nombreEquipo: props.equipo.nombreEquipo!,
      };

      const response = await subirListaTorneo(requestLista);
      nuevoIdLista = response.data?.idLista;
    }

    // Reemplazo reactivo del objeto completo
    inscripcionesEquipo.value[miembroIndex] = {
      ...miembro,
      estadoLista: "ENTREGADA",
      listaData: newLista.listaData,
      ejercito: newLista.ejercito.name,
      idLista: nuevoIdLista,
      fechaEntregaLista: obtenerFechaActual(),
    };

    showSuccessModalLista.value = true;
  } catch (error) {
    console.error("Error al guardar/modificar lista:", error);
    showErrorModalLista.value = true;
  } finally {
    isCargandoAccion.value = false;
  }
};

const cambiarEstadoLista = (
  idInscripcion: number,
  estadoLista: string,
  nick: string
) => {
  currentInscripcionId.value = idInscripcion;
  currentNick.value = nick;
  currentEstadoLista.value = estadoLista;
  showCambiarEstadoLista.value = true;
};
const cambiarEstado = (payload: {
  field: keyof InscripcionTorneoDTO;
  value: unknown;
}) => {
  const { field, value } = payload;

  const index = inscripcionesEquipo.value.findIndex(
    (i) => i.idInscripcion === currentInscripcionId.value
  );

  if (index !== -1) {
    // Aseguramos reactividad reemplazando el objeto completo
    inscripcionesEquipo.value[index] = {
      ...inscripcionesEquipo.value[index],
      [field]: value,
    };
  }
};

const abrirModalConfirmacion = (
  titulo: string,
  texto: string,
  accion: () => void
) => {
  confirmTitle.value = titulo;
  confirmText.value = texto;
  confirmAction.value = () => {
    showConfirmModal.value = false;
    accion();
  };
  showConfirmModal.value = true;
};

const confirmarActualizarPago = async () => {
  isLoading.value = true;
  try {
    const response = await updateEstadoPagoEquipo({
      idEquipo: props.equipo.idEquipo,
      esPago: "SI",
    });
    if (response.status >= 200 && response.status < 300) {
      showSuccessModalPago.value = true;
      esPago.value = "SI";
    } else {
      console.error("error:", response);
      showErrorModal.value = true;
    }

    showSuccessModalPago.value = true;
    isLoading.value = false;
  } catch (error) {
    console.error("error:", error);
    showErrorModal.value = true;
    isLoading.value = false;
  } finally {
    isLoading.value = false;
  }
};

const confirmarEliminarEquipo = async () => {
  isLoading.value = true;
  try {
    const response = await eliminarEquipoAsync(props.equipo.idEquipo);

    if (response.status >= 200 && response.status < 300) {
      showSuccessModalEliminarEquipo.value = true;
      emit("delete-team");
    } else {
      showErrorModal.value = true;
    }
  } catch (error) {
    console.error("Error al eliminar el equipo:", error);
    showErrorModal.value = true;
    isLoading.value = false;
  } finally {
    isLoading.value = false;
  }
};

const handlerModalRegistrarMiembroEquipo = async () => {
  const responseJugadores = await getUsuariosNoInscritosTorneoAsync(
    props.torneo.idTorneo
  );
  jugadoresSinEquipo.value = (responseJugadores?.data ?? []).sort(
    (a: { nick: string }, b: { nick: string }) => a.nick.localeCompare(b.nick)
  );
  showModalRegistrarMiembroEquipo.value = true;
};

const closeModal = () => {
  showModalRegistrarMiembroEquipo.value = false;
};
const closeConfigModal = (nuevoMiembro: InscripcionTorneoDTO) => {
  if (nuevoMiembro) {
    if (
      !inscripcionesEquipo.value.some(
        (m) => m.idUsuario === nuevoMiembro.idUsuario
      )
    ) {
      inscripcionesEquipo.value.push(nuevoMiembro);
    }
  }
};

const eliminarMiembro = async (idInscripcion: number) => {
  isCargandoAccion.value = true;
  mensajeCarga.value = "Eliminando jugador...";
  try {
    const response = await eliminarMiembroEquipoAsync(idInscripcion);
    if (
      (response.status < 200 && response.status >= 300) ||
      response.data === false
    ) {
      isCargandoAccion.value = false;
      showErrorModalEliminarMiembroEquipo.value = true;
      return;
    }

    inscripcionesEquipo.value = inscripcionesEquipo.value.filter(
      (miembro) => miembro.idInscripcion !== idInscripcion
    );

    showSuccessModalEliminarMiembroEquipo.value = true;
  } catch (error) {
    console.error("Error al borrar un miembro: ", error);
    showErrorModalEliminarMiembroEquipo.value = true;
  } finally {
    isCargandoAccion.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "card-equipo",
      onClick: toggleExpand
    }, [
      _createVNode(_component_v_card, {
        elevation: "15",
        class: _normalizeClass(["ma-2 pa-3", {
        'border-warning': equipoIncompleto.value,
        'border-green': esPago.value === 'SI' && !equipoIncompleto.value,
      }])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "align-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "5",
                class: "d-flex align-center justify-start"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_avatar, { size: "40" }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.equipo.nombreEquipo), 1),
                      _createVNode(_component_v_spacer, { class: "d-none d-sm-flex" }),
                      _createElementVNode("span", _hoisted_5, [
                        _createTextVNode(_toDisplayString(inscripcionesEquipo.value.length) + "/" + _toDisplayString(numeroMiembrosEquipo.value) + " jugadores ", 1),
                        _hoisted_6,
                        _createTextVNode(" " + _toDisplayString(listasOk.value) + "/" + _toDisplayString(numeroMiembrosEquipo.value) + " listas OK ", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_v_chip, {
                        class: "mt-1",
                        color: _ctx.equipo.esPago === 'SI' ? 'green' : 'red',
                        variant: "tonal",
                        "x-small": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            size: "16",
                            class: "me-1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-cash")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Pago: " + _toDisplayString(_ctx.equipo.esPago), 1)
                        ]),
                        _: 1
                      }, 8, ["color"])
                    ]),
                    (equipoIncompleto.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createVNode(_component_v_icon, {
                            size: "16",
                            class: "me-1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-alert-circle")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" ATENCIÓN: Faltan listas por validar ")
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "4",
                class: "text-caption text-md-left text-center"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_v_icon, {
                      size: "18",
                      class: "me-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-account-star")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.equipo.nickCapitan), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_v_icon, {
                      size: "18",
                      class: "me-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-email")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("a", {
                      href: `mailto:${_ctx.equipo.emailCapitan}`,
                      class: "text-decoration-none",
                      target: "_blank"
                    }, _toDisplayString(_ctx.equipo.emailCapitan), 9, _hoisted_11)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_v_icon, {
                      size: "18",
                      class: "me-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-calendar")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(_unref(convertirFecha)(_ctx.equipo.fechaInscripcion!)), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "3",
                class: "d-flex flex-column align-end justify-center mt-2 mt-sm-0"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_v_btn, {
                    variant: "tonal",
                    color: "warning",
                    size: "small",
                    class: "mb-1",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
              () =>
                abrirModalConfirmacion(
                  'Marcar equipo como pagado?',
                  '¿Seguro que quieres actualizar el estado de pago a SI?',
                  confirmarActualizarPago
                )
            , ["stop"])),
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { class: "me-1" }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-credit-card-edit")
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" Modificar Pago ")
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.equipo.esPago === 'NO']
                  ]),
                  _createVNode(_component_v_btn, {
                    color: "red",
                    variant: "tonal",
                    size: "small",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (
              abrirModalConfirmacion(
                '¿Deseas borrar el equipo?',
                'Esta acción no se puede deshacer.',
                confirmarEliminarEquipo
              )
            ), ["stop"])),
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { class: "me-1" }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-trash-can")
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" Borrar equipo ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_expand_transition, null, {
            default: _withCtx(() => [
              (isExpanded.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_v_divider, { class: "mb-2" }),
                    _createVNode(_component_v_data_table, {
                      items: equipoConHuecos.value,
                      class: "styled-table",
                      dense: ""
                    }, {
                      headers: _withCtx(() => [
                        _hoisted_14
                      ]),
                      item: _withCtx(({ item }) => [
                        item
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                              _createElementVNode("td", _hoisted_16, [
                                _createVNode(_component_v_avatar, {
                                  size: "40",
                                  class: "hide-on-mobile"
                                }, {
                                  default: _withCtx(() => [
                                    (item.idUsuario === _ctx.equipo.idCapitan)
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_17))
                                      : (_openBlock(), _createElementBlock("img", _hoisted_18))
                                  ]),
                                  _: 2
                                }, 1024),
                                _createTextVNode("  " + _toDisplayString(item.nick || "Desconocido"), 1)
                              ]),
                              _createElementVNode("td", _hoisted_19, _toDisplayString(item.ejercito || "No asignado"), 1),
                              _createElementVNode("td", _hoisted_20, [
                                _createVNode(_component_v_chip, {
                                  color: 
                      item.estadoLista === 'OK'
                        ? 'green'
                        : item.estadoLista === 'ENTREGADA'
                        ? 'yellow'
                        : 'red'
                    ,
                                  variant: "tonal"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.estadoLista), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color"])
                              ]),
                              _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(formatFechaSpaWhitoutAsync)(item.fechaEntregaLista) || "N/A"), 1),
                              _createElementVNode("td", _hoisted_22, [
                                _createVNode(_component_v_menu, {
                                  modelValue: isOpenMenuAcciones.value[item.idInscripcion],
                                  "onUpdate:modelValue": ($event: any) => ((isOpenMenuAcciones.value[item.idInscripcion]) = $event),
                                  "offset-y": ""
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_btn, _mergeProps({
                                      color: "primary",
                                      variant: "tonal"
                                    }, props), {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("mdi-dots-vertical")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1040)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list, null, {
                                      default: _withCtx(() => [
                                        (item.idLista)
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 0,
                                              onClick: _withModifiers(($event: any) => {
                          verLista(item.idLista, item.nick, item.ejercito);
                          isOpenMenuAcciones.value[item.idInscripcion] = false;
                        }, ["stop"])
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_icon, { class: "me-2" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("mdi-eye")
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createTextVNode(" Ver Lista ")
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (item.idLista)
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 1,
                                              onClick: _withModifiers(($event: any) => {
                          cambiarEstadoLista(
                            item.idInscripcion!,
                            item.estadoLista,
                            item.nick
                          );
                          isOpenMenuAcciones.value[item.idInscripcion] = false;
                        }, ["stop"])
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_icon, { class: "me-2" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("mdi-refresh")
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createTextVNode(" Cambiar Estado ")
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_v_list_item, {
                                          onClick: _withModifiers(($event: any) => {
                          enviarCambiarLista(
                            item.idInscripcion,
                            item.listaData!,
                            item.idUsuario,
                            item.nick,
                            item.idLista
                          );
                          isOpenMenuAcciones.value[item.idInscripcion] = false;
                        }, ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_icon, { class: "me-2" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("mdi-pencil")
                                                  ]),
                                                  _: 1
                                                }),
                                                (item.listaData)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Modificar lista"))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_24, "Enviar lista"))
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        _createVNode(_component_v_divider, { class: "my-2" }),
                                        _createVNode(_component_v_list_item, {
                                          onClick: _withModifiers(($event: any) => {
                          eliminarMiembro(item.idInscripcion);
                          isOpenMenuAcciones.value[item.idInscripcion] = false;
                        }, ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_icon, {
                                                  color: "red",
                                                  class: "me-2"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("mdi-account-remove")
                                                  ]),
                                                  _: 1
                                                }),
                                                _createTextVNode(" Eliminar del equipo ")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                              _createElementVNode("td", _hoisted_26, [
                                _createVNode(_component_v_btn, {
                                  color: "primary",
                                  variant: "outlined",
                                  size: "small",
                                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (handlerModalRegistrarMiembroEquipo()), ["stop"]))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { class: "me-1" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("mdi-account-plus")
                                      ]),
                                      _: 1
                                    }),
                                    _createTextVNode(" Añadir jugador ")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]))
                      ]),
                      _: 1
                    }, 8, ["items"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    (showCambiarEstadoLista.value)
      ? (_openBlock(), _createBlock(ModalCambiarEstadoListaEquipos, {
          key: currentInscripcionId.value,
          isVisible: showCambiarEstadoLista.value,
          "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => ((showCambiarEstadoLista).value = $event)),
          idInscripcion: currentInscripcionId.value!,
          "estado-lista": currentEstadoLista.value!,
          nick: currentNick.value!,
          onUpdateInscripcion: cambiarEstado
        }, null, 8, ["isVisible", "idInscripcion", "estado-lista", "nick"]))
      : _createCommentVNode("", true),
    _createVNode(ModalVerLista, {
      isVisible: showVerListaModal.value,
      "onUpdate:isVisible": _cache[4] || (_cache[4] = ($event: any) => ((showVerListaModal).value = $event)),
      listaJugador: listaJugador.value!
    }, null, 8, ["isVisible", "listaJugador"]),
    (showEnviarCambiarListaModal.value)
      ? (_openBlock(), _createBlock(ModalEnviarLista, {
          key: currentInscripcionId.value,
          isVisible: showEnviarCambiarListaModal.value,
          "onUpdate:isVisible": _cache[5] || (_cache[5] = ($event: any) => ((showEnviarCambiarListaModal).value = $event)),
          idInscripcion: currentInscripcionId.value!,
          idUsuario: currentUsuarioId.value!,
          idTorneo: currentTorneoId.value!,
          emailOrganizador: currentEmailOrganziador.value!,
          nick: currentNick.value!,
          hasLista: hasLista.value,
          onEnviarLista: guardarLista,
          onModificarLista: guardarLista
        }, null, 8, ["isVisible", "idInscripcion", "idUsuario", "idTorneo", "emailOrganizador", "nick", "hasLista"]))
      : _createCommentVNode("", true),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModalLista.value,
      message: "Lista enviada con éxito.",
      "onUpdate:isVisible": _cache[6] || (_cache[6] = ($event: any) => (showSuccessModalLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModalPago.value,
      message: "Estado del pago actualizado.",
      "onUpdate:isVisible": _cache[7] || (_cache[7] = ($event: any) => (showSuccessModalPago.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModalEliminarEquipo.value,
      message: "Equipo eliminado.",
      "onUpdate:isVisible": _cache[8] || (_cache[8] = ($event: any) => (showSuccessModalEliminarEquipo.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido actualizar la inscripción. Contacta con el administrador.",
      "onUpdate:isVisible": _cache[9] || (_cache[9] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModalEliminarMiembroEquipo.value,
      message: "Miembro eliminado con éxito.",
      "onUpdate:isVisible": _cache[10] || (_cache[10] = ($event: any) => (showSuccessModalLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModalEliminarMiembroEquipo.value,
      message: "No se ha podido eliminar al miembro del equipo. Inténtelo de nuevo y si el error persiste contacta con el administrador.",
      "onUpdate:isVisible": _cache[11] || (_cache[11] = ($event: any) => (showErrorModalLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalAddMiembroEquipo, {
      isVisible: showModalRegistrarMiembroEquipo.value,
      "onUpdate:isVisible": _cache[12] || (_cache[12] = ($event: any) => ((showModalRegistrarMiembroEquipo).value = $event)),
      idEquipo: _ctx.equipo.idEquipo,
      idTorneo: _ctx.torneo.idTorneo!,
      jugadores: jugadoresSinEquipo.value,
      onClose: closeModal,
      onConfirm: closeConfigModal
    }, null, 8, ["isVisible", "idEquipo", "idTorneo", "jugadores"]),
    _createVNode(_component_v_dialog, {
      modelValue: isLoading.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((isLoading).value = $event)),
      "hide-overlay": "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "progress-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "70"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: isCargandoAccion.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((isCargandoAccion).value = $event)),
      persistent: "",
      width: "250",
      "hide-overlay": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "d-flex flex-column justify-center align-center pa-4",
          height: "180"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "50",
              class: "mb-4"
            }),
            _createElementVNode("div", _hoisted_27, _toDisplayString(mensajeCarga.value), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showConfirmModal.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((showConfirmModal).value = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h6" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(confirmTitle.value), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(confirmText.value), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "grey",
                  variant: "text",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (showConfirmModal.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancelar ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "tonal",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (confirmAction.value?.()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Confirmar ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})